import { motion } from 'framer-motion'
import { FaLinkedin, FaGithub, FaDribbble, FaHeart } from 'react-icons/fa'
import type { Language } from '../App'
import { personalInfo } from '../utils/data'
import './Footer.css'

interface FooterProps { language: Language }

export default function Footer({ language: _language }: FooterProps) {
  const socials = [
    { icon: <FaLinkedin />, href: personalInfo.linkedin, label: 'LinkedIn' },
    { icon: <FaGithub />,   href: personalInfo.github,   label: 'GitHub' },
    { icon: <FaDribbble />, href: personalInfo.dribbble,  label: 'Dribbble' },
  ]

  const navLinks = ['About Me', 'Skills', 'Experience', 'Education', 'Projects', 'Certificates', 'Contact']
  const ids      = ['about',   'skills', 'experience', 'education', 'projects', 'certificates', 'contact']

  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-top">
          {/* Brand */}
          <div className="footer-brand">
            <div className="footer-logo">
              <div className="logo-icon"><span>K</span></div>
              <span className="logo-text">Kenil Balar</span>
            </div>
            <p className="footer-tagline">
              Building elegant solutions to complex problems. Passionate about clean code, great UX, and continuous learning.
            </p>
            <div className="footer-socials">
              {socials.map((s, i) => (
                <motion.a
                  key={i}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social"
                  whileHover={{ scale: 1.15, y: -2 }}
                  aria-label={s.label}
                >
                  {s.icon}
                </motion.a>
              ))}
            </div>
          </div>

          {/* Nav */}
          <div className="footer-nav">
            <h4 className="footer-nav-title">Quick Links</h4>
            <ul>
              {navLinks.map((label, i) => (
                <li key={i}>
                  <button
                    className="footer-link"
                    onClick={() => document.getElementById(ids[i])?.scrollIntoView({ behavior: 'smooth' })}
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact summary */}
          <div className="footer-contact">
            <h4 className="footer-nav-title">Contact</h4>
            <div className="footer-contact-items">
              <a href={`mailto:${personalInfo.email}`} className="footer-contact-item">{personalInfo.email}</a>
              <a href={`tel:${personalInfo.phone}`} className="footer-contact-item">{personalInfo.phone}</a>
              <span className="footer-contact-item">{personalInfo.location}</span>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copy">
            © {new Date().getFullYear()} {personalInfo.name}. All rights reserved.
          </p>
          <p className="footer-made">
            Made with <FaHeart className="footer-heart" /> using React + TypeScript
          </p>
        </div>
      </div>
    </footer>
  )
}
